import { FC, PropsWithChildren } from 'react';

import { SharedLink } from '../link/SharedLink';
import { FontIcons } from '../icons/FontIcons';

import { LinkButtonProps } from './constants';
import { getButtonStyle } from './utils';

export const LinkButton: FC<PropsWithChildren<LinkButtonProps>> = ({
  href,
  icon,
  fullSizeOverlay,
  variant = 'primary',
  children,
  target,
  className,
  iconClassName,
  size,
  theme = 'default',
  'data-testid': dataTestId,
}) => {
  // если размер маленький и нет иконки, то кнопка не отображается, то есть можно рендерить маленькую кнопку только с иконкой
  if (!href || (!children && size !== 'small' && (icon !== 'none' || !icon)))
    return null;

  const iconRight = icon !== 'download' && icon !== 'arrowLeft';
  return (
    <SharedLink
      href={href}
      className={getButtonStyle({ variant, iconRight, className, size })}
      underlineSize={0}
      target={target}
      underline='off'
      data-theme={theme}
      fullSizeOverlay={fullSizeOverlay}
      data-testid={dataTestId}
    >
      <FontIcons icon={icon} className={iconClassName} />
      {children}
    </SharedLink>
  );
};
